import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { Check, AlertTriangle } from "lucide-react";
import { useApp, API } from "../store";

export default function PixCheckout() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  const mocked = params.get("mocked") === "1";
  const [status, setStatus] = useState("pending");
  const [data, setData] = useState(null);
  const { clearCart } = useApp();

  useEffect(() => {
    if (!orderId) return;
    let attempts = 0;
    const poll = async () => {
      try {
        const r = await axios.get(`${API}/payments/pix/status/${orderId}`);
        setData(r.data);
        if (r.data.payment_status === "paid") { setStatus("paid"); clearCart(); return; }
        if (r.data.payment_status === "expired") { setStatus("expired"); return; }
        attempts++;
        if (attempts < 30) setTimeout(poll, 4000);
      } catch {
        attempts++;
        if (attempts < 5) setTimeout(poll, 4000);
      }
    };
    poll();
  }, [orderId, clearCart]);

  return (
    <main className="pt-32 pb-32 bg-white min-h-screen grid place-items-center" data-testid="pix-checkout">
      <div className="max-w-xl text-center px-6">
        {status === "paid" ? (
          <>
            <div className="w-20 h-20 rounded-full bg-sky-500 grid place-items-center mx-auto"><Check size={40} className="text-white" /></div>
            <h1 className="font-serif-display text-5xl md:text-7xl mt-8 text-slate-900">Pagamento PIX confirmado.</h1>
          </>
        ) : (
          <>
            {mocked && (
              <div className="bg-amber-50 border border-amber-200 rounded-md p-4 mb-8 flex gap-3 items-start text-left">
                <AlertTriangle size={18} className="text-amber-600 mt-0.5 flex-shrink-0" />
                <div className="text-amber-900 text-sm">
                  <strong>PIX MOCKED:</strong> O fluxo está completo, mas a InfinitePay ainda não está conectada. Configure <code className="bg-amber-100 px-1 rounded">INFINITEPAY_HANDLE</code> no backend para ativar.
                </div>
              </div>
            )}
            <div className="overline">Aguardando pagamento</div>
            <h1 className="font-serif-display text-4xl md:text-5xl mt-4 text-slate-900">Pague com PIX</h1>
            <p className="text-slate-600 mt-4">
              Pedido <code className="bg-slate-100 px-2 py-1 rounded text-sm">{orderId?.slice(0, 8)}</code>
            </p>
            {data?.amount_brl && (
              <div className="mt-6 bg-slate-50 border border-slate-200 rounded-md p-6 inline-block">
                <div className="overline">Valor</div>
                <div className="font-serif-display text-4xl text-sky-600">R$ {data.amount_brl.toFixed(2)}</div>
              </div>
            )}
            <p className="text-slate-500 text-sm mt-6">
              Esta tela é atualizada automaticamente assim que confirmarmos seu pagamento. Você pode fechar a janela e o pedido continuará sendo processado.
            </p>
          </>
        )}
        <Link to="/" className="btn-ghost mt-10 inline-flex">Voltar ao site</Link>
      </div>
    </main>
  );
}
